import { Module } from "vuex";
import { RootState } from "../types";
import { DraftsInterface } from "./types";
import { getters } from "./getter";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
  error: "",
  data: [],
} as DraftsInterface;

export const drafts: Module<DraftsInterface, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
